import { Button, ButtonGroup, DialogBody, DialogFooter, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";
import { toaster } from "config";
import { API } from "config";
import useOrder from "hooks/useOrder";
import { useState } from "react";

export default function Dispatch({ data = {}, ...props }){

    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)

    const handleApprove = async () => {
        if(!window.confirm('Tem certeza que deseja continuar?')) return
        setLoading(true)

        try{
            await API.put(`/orders/${order?.data?.id}/transit`)
            toaster.create({ title: 'O pedido foi despachado para envio', type: 'success' })
            order.refetch()
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível altera o status do pedido', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog loading={loading} size="sm" title={`Despachar pedido #${order.data?.cod}?`} {...props}>
        <DialogBody>
            <Stack gap={3}>
                <Text fontSize="sm">Caso já tenha montado o pedido e entregado à transportadora, prossiga para o status <b>Em trânsito</b>.</Text>
                <Text>Tem certeza que deseja prosseguir?</Text>
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup>
                <Button loading={loading} loadingText="Despachando pedido..." variant="subtle" colorPalette="blue" onClick={handleApprove}><UI.Icon name="transit" /> Despachar pedido</Button>
                <Button disabled={loading} variant="ghost" onClick={props.onClose}>Fechar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )    
}